import React, { Component } from "react";
import { withGetScreen } from "react-getscreen";

import TopHeader from "../components/shared/TopHeader";
import SaleDetailsInfoPanel from "../components/sale-details/SaleDetailsInfoPanel";
import SaleDetailsFlightPanel from "../components/sale-details/SaleDetailsFlightPanel";
import { getUserSaleDetailed } from "../shared/requests-api";
import Loading from "../../shared/Loading/Loading";

class SaleDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			item: {},
			loading: false
		};

		this.body = document.getElementById("body");

		this.keyCodeCloseModal = this.keyCodeCloseModal.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.handlerModal(nextProps);
	}

	handlerModal(props) {
		if (props.open) {
			this.setState({
				loading: true
			});
			getUserSaleDetailed(undefined, props.item)
				.then(response => {
					this.setState({
						open: props.open,
						item: response.data,
						loading: false
					});
				})
				.catch(err => {
					console.log(err);
				});
		} else {
			this.setState({
				open: props.open,
				loading: false
			});
		}
	}

	keyCodeCloseModal(e) {
		if (e.keyCode == 27) {
			this.props.close(e);
		}
	}

	componentWillMount() {
		window.addEventListener("keyup", this.keyCodeCloseModal);
		this.handlerModal(this.props);
	}

	componentWillUnmount() {
		window.removeEventListener("keyup", this.keyCodeCloseModal);
	}

	render() {
		return (
			<div className={this.props.className}>
				{this.state.loading && <Loading label="Carregando dados..." />}
				{this.state.open && (
					<div
						className={`offers-sale-details-modal
								${this.state.item.status === 1 ? "received" : ""}
								${this.state.item.status === 2 ? "receive" : ""}
								${this.state.item.status === 3 ? "canceled" : ""}
							`}
					>
						<SaleDetailsInfoPanel close={e => this.props.close(e)} item={this.state.item} />
						<SaleDetailsFlightPanel item={this.state.item} />
					</div>
				)}
			</div>
		);
	}
}

export default SaleDetails;

// export default withGetScreen(
// 	SaleDetails,
// 	{
// 		mobileLimit: 468, // TODO Fix screen vars
// 		tabletLimit: 768, // TODO Fix screen vars
// 		shouldListenOnResize: true
// 	});
